import React from 'react';
import Layout from '../../components/layout/Layout';
import { BasicProps } from '../goals/GoalPage';

const TaskPage = (props: BasicProps) => {
  return <Layout pageName="Task" {...props}></Layout>;
};

export default TaskPage;
